import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement } from 'rax';
import Text from 'rax-text';
import View from '../view';
import { isString } from '../utils';
const Divider = (props) => {
    const { prefix = 'mt-', orientation, dashed = false, direction = 'hoz', children, className } = props, others = __rest(props, ["prefix", "orientation", "dashed", "direction", "children", "className"]);
    const clsPrefix = `${prefix}divider`;
    const clses = {
        divider: classNames(className, clsPrefix, `${clsPrefix}--${direction}`, {
            [`${clsPrefix}--dashed`]: dashed,
            [`${clsPrefix}--${orientation}`]: orientation,
        }),
        text: classNames(`${clsPrefix}-text`, `${clsPrefix}-text--${direction}`, `${clsPrefix}-text--${orientation}`),
    };
    const renderChildren = () => {
        if (direction === 'hoz' && children) {
            if (isString(children)) {
                return <Text className={clses.text}>{children}</Text>;
            }
            else {
                return <View className={clses.text}>{children}</View>;
            }
        }
        return null;
    };
    return (<View {...others} className={clses.divider}>
      {renderChildren()}
    </View>);
};
Divider.displayName = 'Divider';
export default Divider;
